import { useAppDispatch } from '@/app/redux/hooks';
import { useOrganisation } from '@/app/redux/hooks/organisation';
import { setContactFormModalOpen } from '@/app/redux/slices/modalsSlice';
import FeatureTable from '@/common/ui/FeatureTable';
import { Button } from '@shadcn/components/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@shadcn/components/dialog';
import { useEffect } from 'react';

interface TrialEndedModalProps {
  onClose: () => void;
}
export default function TrialEndedModal({ onClose }: TrialEndedModalProps) {
  const dispatch = useAppDispatch();

  const { organisation } = useOrganisation();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Dialog open={true} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-3xl flex flex-col max-h-[90vh]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold">
            {organisation?.name || 'Your organisation'}'s trial period has ended
          </DialogTitle>
          <DialogDescription>
            You still have access to Lesson Plans and Word Mats. To unlock the
            Spellcaster game, assessments, and full platform features, select
            from the plans below.
          </DialogDescription>
        </DialogHeader>

        <div className="overflow-auto min-h-0 flex-1 pt-4">
          <FeatureTable showRecommended showPricing showCTAs />
        </div>

        <DialogFooter className="sm:justify-between">
          <div className="flex items-center">
            <span className="text-sm font-medium">
              Need a little more time?
            </span>

            <Button
              variant="link"
              onClick={() => {
                onClose();
                dispatch(setContactFormModalOpen(true));
              }}
              className="px-2"
            >
              Request an extension
            </Button>
          </div>

          <DialogClose asChild>
            <Button variant="outline">Not now</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
